const JsonPointer = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
/**
 * Returns true if the value is a json pointer
 * @specification
 * @source ajv-formats
 */
export function IsJsonPointer(value) {
    return JsonPointer.test(value);
}
